import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Global/Buttons/Button';
import ErrorText from "../Global/Forms/ErrorText";
import Label from "../Global/Forms/Label";
import TextInput from "../Global/Forms/TextInput";
import ModalBody from "../Global/Modals/ModalBody";
import ModalContainer from "../Global/Modals/ModalContainer";
import ModalFooter from "../Global/Modals/ModalFooter";
import ModalHeader from "../Global/Modals/ModalHeader";
import ModalPadding from "../Global/Modals/ModalPadding";

const FoldersCreateModal = ({ children, modalIsOpen, onCloseClick, onSubmitClick, onInputChange, onAfterOpen, inputValue, inputRef, nameExists, folderLocation, loading, ...rest }) => {
  const disabled = inputValue.length === 0 || nameExists || folderLocation === 0;
  return (
    <ModalContainer isOpen={modalIsOpen} closeModal={onCloseClick} onAfterOpen={onAfterOpen} label="Add to Folder Modal">
      <ModalHeader title={`Create a folder`} onCloseClick={onCloseClick} {...rest} />
      <ModalBody>
        <ModalPadding>
          <TextInput
            name="folder-name"
            placeholder="Folder name e.g. Shooting practices"
            onChange={onInputChange}
            value={inputValue}
            maxLength={30}
            inputRef={inputRef}
          />
          {nameExists && <ErrorText>A folder with this title already exists</ErrorText>}
        </ModalPadding>

        <ModalPadding>
          <Label name="folder-path">Select location of new folder</Label>
        </ModalPadding>

        { children }

      </ModalBody>

      <ModalFooter>
        <Button type="submit" onClick={onSubmitClick} disabled={disabled} loading={loading}>
          Create
        </Button>
      </ModalFooter>
    </ModalContainer>
  );
}

FoldersCreateModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  modalIsOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onSubmitClick: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  onAfterOpen: PropTypes.func,
  inputValue: PropTypes.string,
  inputRef: PropTypes.func,
  nameExists: PropTypes.bool,
  folderLocation: PropTypes.number,
  loading: PropTypes.bool,
};

export default FoldersCreateModal;



// WEBPACK FOOTER //
// ./library/app/components/Folders/AddToFoldersCreateModal.js